import { useState } from 'react';
import { useStripe, useElements } from '@stripe/react-stripe-js';

export const useCreateStripeToken = () => {
  const [isStripeLoading, setIsStripeLoading] = useState(false);
  const [data, setData] = useState(null);
  const stripe = useStripe();
  const elements = useElements();

  const createToken = async () => {
    const cardElement = elements?.getElement('cardNumber');
    const elementsList = elements?._elements || [];
    // if a stripe element is invalid or empty, don't make api call
    for (const el of elementsList) {
      const classList = el?._parent?.classList || [];
      if (
        classList.contains('StripeElement--invalid') ||
        classList.contains('StripeElement--empty')
      ) {
        el?.focus();
        return;
      }
    }

    setIsStripeLoading(true);
    const res = await stripe.createToken(cardElement);
    const cardRes = {
      token: res?.token?.id,
      last4: res?.token?.card?.last4,
      country: res?.token?.card?.country,
      brand: res?.token?.card?.brand
    };

    setData(cardRes);
    setIsStripeLoading(false);
    return cardRes;
  };

  return {
    data,
    createToken,
    isStripeLoading
  };
};



// WEBPACK FOOTER //
// ./src/vp-ui/hooks/useCreateStripeToken.js